
/**
 * A function that returns the URL part common to the endpoints.
 */
export const root = () => {
    let __root = "";
    
    if (process.env.RUNTIME_ENV === "local") {       
        __root = "http://localhost:7999";
    }

    if (process.env.RUNTIME_ENV === "development") {       
        __root = "https://api-cleaning.dev.m2msystems.cloud";
    }

    if (process.env.RUNTIME_ENV === "production") {       
        __root = "https://api-cleaning.m2msystems.cloud";
    }
    return __root
}

/**
 * 清掃員応募者を RISK EYES で反社チェックし、判定 (そのまま案内 / ジョブカン申請) を保存して返す。有効期間内の判定があれば再利用する
 * 
 */
export const checkCleanerApplicantAntisocial = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/antisocial_checks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
checkCleanerApplicantAntisocial.method = "POST" as const;

/**
 * 清掃員応募者の反社チェック履歴を検索する
 * 
 */
export const searchAntisocialChecks = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/antisocial_checks/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchAntisocialChecks.method = "POST" as const;

/**
 * 判定が escalate の反社チェックについて、該当記事を RISK EYES の画面で確認する URL を発行する。URL は 30 分で失効するので開く直前に呼ぶ
 * 
 */
export const issueAntisocialCheckArticleListUrl = ({checkId}: {checkId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/antisocial_checks/${checkId}/article_list_url`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueAntisocialCheckArticleListUrl.method = "POST" as const;

/**
 * エリア(CityGroup)を作成する
 * 
 */
export const createCityGroups = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/city_groups`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createCityGroups.method = "POST" as const;

/**
 * エリア(CityGroup)を削除する
 * 
 */
export const deleteCityGroup = ({cityGroupId}: {cityGroupId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/city_groups/${cityGroupId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteCityGroup.method = "DELETE" as const;

/**
 * エリア(CityGroup)を更新する
 * 
 */
export const updateCityGroups = ({cityGroupId}: {cityGroupId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/city_groups/${cityGroupId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateCityGroups.method = "PUT" as const;

/**
 * エリア(CityGroup)を取得する
 * 
 */
export const readCityGroups = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/city_groups`;
    return __queries ? `${__path}?${__queries}` : __path;
};
readCityGroups.method = "GET" as const;

/**
 * エリア(CityGroup)を並び替える
 * 
 */
export const reorderCityGroups = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/city_groups/reorder`;
    return __queries ? `${__path}?${__queries}` : __path;
};
reorderCityGroups.method = "POST" as const;

/**
 * 清掃員の評価を保存する
 * 
 */
export const saveCleanerAssessment = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_assessment/save`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCleanerAssessment.method = "PUT" as const;

/**
 * 清掃員の自動アサイン対象フラグを保存する
 * 
 */
export const saveCleanerAutoAssignEnabled = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_auto_assign_enabled/save`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCleanerAutoAssignEnabled.method = "PUT" as const;

/**
 * 清掃員の基本情報を保存する
 * 
 */
export const saveCleanerFactor = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_factors/save`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCleanerFactor.method = "PUT" as const;

/**
 * 管理者が一人の清掃員の自宅を登録する
 * 
 */
export const saveCleanerHome = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_homes/save`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCleanerHome.method = "PUT" as const;

/**
 * 清掃員が、自身のパスを取得する
 * 
 */
export const listCleanerHome = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_homes/list`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCleanerHome.method = "POST" as const;

/**
 * 清掃員の備考を保存する
 * 
 */
export const saveCleanerRemarks = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_remarks/save`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCleanerRemarks.method = "PUT" as const;

/**
 * 清掃員のスキルを保存する
 * 
 */
export const saveCleanerSkill = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_skills/save`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCleanerSkill.method = "PUT" as const;

/**
 * 清掃員のタグを保存する
 * 
 */
export const saveCleanerTag = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_tags/save`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCleanerTag.method = "PUT" as const;

/**
 * 清掃員のタグを全て削除する
 * 
 */
export const deleteAllCleanerTags = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_tags/delete_all`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteAllCleanerTags.method = "PUT" as const;

/**
 * 清掃員の単価を保存する
 * 
 */
export const saveCleanerUnitPrice = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_unit_price/save`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCleanerUnitPrice.method = "PUT" as const;

/**
 * 清掃員のid列から、清掃員の単価を検索する
 * 
 */
export const findCleanerUnitPricesByCleanerIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_unit_price/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleanerUnitPricesByCleanerIds.method = "POST" as const;

/**
 * 自分に対する Feature Flag の評価結果を取得する
 * 
 */
export const getFeatureFlags = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/feature_flags`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getFeatureFlags.method = "GET" as const;

/**
 * Feature Flag の一覧と公開状態を取得する
 * 
 */
export const listFeatureFlagDefinitions = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/feature_flags/definitions`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listFeatureFlagDefinitions.method = "GET" as const;

/**
 * Feature Flag の適用対象に指定できる業者の一覧を取得する
 * 
 */
export const listFeatureFlagTargetCompanies = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/feature_flags/definitions/companies`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listFeatureFlagTargetCompanies.method = "GET" as const;

/**
 * Feature Flag のステータス(draft/active/retired)を変更する
 * 
 */
export const updateFeatureFlagStatus = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/feature_flags/definitions/status`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateFeatureFlagStatus.method = "POST" as const;

/**
 * Feature Flag の全体公開を切り替える
 * 
 */
export const updateFeatureFlagGlobalEnabled = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/feature_flags/definitions/global`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateFeatureFlagGlobalEnabled.method = "POST" as const;

/**
 * Feature Flag の適用対象(業者・ユーザー)を追加する
 * 
 */
export const addFeatureFlagTargets = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/feature_flags/definitions/targets`;
    return __queries ? `${__path}?${__queries}` : __path;
};
addFeatureFlagTargets.method = "POST" as const;

/**
 * コードから削除済みの Feature Flag の設定を掃除する
 * 
 */
export const deleteRetiredFeatureFlag = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/feature_flags/definitions/delete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteRetiredFeatureFlag.method = "POST" as const;

/**
 * Feature Flag の適用対象を削除する
 * 
 */
export const deleteFeatureFlagTarget = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/feature_flags/definitions/targets/delete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteFeatureFlagTarget.method = "POST" as const;

/**
 * 管理画面の「フィードバックを送信」から届いた投稿を新しい順に返す (matsuri 社員のみ)。BigQuery のレプリカから読むため、反映は最大で数時間遅れる
 * 
 */
export const searchFeedbacks = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/feedbacks/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchFeedbacks.method = "POST" as const;

/**
 * 清掃員IDと日付を指定して、交通経路と交通費を登録する
 * 
 */
export const registerCleanerPathWithCleanerId = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_paths/register_for_cleaner`;
    return __queries ? `${__path}?${__queries}` : __path;
};
registerCleanerPathWithCleanerId.method = "POST" as const;

/**
 * 清掃員のパスを登録する
 * 
 */
export const registerCleanerPath = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_paths/register`;
    return __queries ? `${__path}?${__queries}` : __path;
};
registerCleanerPath.method = "POST" as const;

/**
 * 管理者が、清掃員達のパスを取得する
 * 
 */
export const listCleanerPath = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_paths/list`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCleanerPath.method = "POST" as const;

/**
 * 管理者が、日付とUserIdを指定して、清掃員のパスを取得する
 * 
 */
export const listCleanerPathByDateAndUser = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_paths/list_by_date_and_user`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCleanerPathByDateAndUser.method = "POST" as const;

/**
 * 管理者が、清掃員の交通費を更新する
 * 
 */
export const updateCleanerPath = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_paths`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateCleanerPath.method = "PUT" as const;

/**
 * 清掃員のロールをリストする
 * 
 */
export const listCleanerRolesByUserIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_roles`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCleanerRolesByUserIds.method = "POST" as const;

/**
 * 清掃員のロールを保存する
 * 
 */
export const saveCleanerRole = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaner_roles/save`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCleanerRole.method = "POST" as const;

/**
 * 清掃員の詳細情報を取得する
 * 
 */
export const findDetailsByCleanerIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaners/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findDetailsByCleanerIds.method = "POST" as const;

/**
 * 清掃員に対してアサインされている清掃IDを取得する
 * 
 */
export const findCleaningIdsByDateAndCleanerIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaners/cleanings`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleaningIdsByDateAndCleanerIds.method = "POST" as const;

/**
 * 清掃員のタグ情報を取得する
 * 
 */
export const findCleanerTagsByCleanerIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaners/tags`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleanerTagsByCleanerIds.method = "POST" as const;

/**
 * 清掃のステータスを取得する
 * 
 */
export const getCleaningStatus = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaning/status`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleaningStatus.method = "POST" as const;

/**
 * 清掃のタイムラインを取得する
 * 
 */
export const getCleaningTimeline = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaning/timeline`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleaningTimeline.method = "GET" as const;

/**
 * 清掃の変更通知を受け取るWebhook URLを取得する
 * 
 */
export const getCleaningWebhook = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaning_event/webhook`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleaningWebhook.method = "GET" as const;

/**
 * 清掃の変更通知を受け取るWebhook URLを保存する
 * 
 */
export const saveCleaningWebhook = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaning_event/webhook`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCleaningWebhook.method = "PUT" as const;

/**
 * 特定日の清掃一覧を取得（ページネーション、フィルタ、ソート対応）
 * 
 */
export const listCleaningsForDay = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/for_day`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCleaningsForDay.method = "POST" as const;

/**
 * 特定日の清掃一覧をCSV形式でエクスポート
 * 
 */
export const exportCleaningsForDayCsv = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/for_day/csv`;
    return __queries ? `${__path}?${__queries}` : __path;
};
exportCleaningsForDayCsv.method = "POST" as const;

/**
 * 特定日の清掃の統計情報（リネン数の合計）を取得（フィルタ条件で絞り込み、清掃回数で重み付け）
 * 
 */
export const getCleaningsForDayStatistics = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/for_day/statistics`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleaningsForDayStatistics.method = "POST" as const;

/**
 * CleaningId配列からCleaningを取得する
 * 
 */
export const findCleanings = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/find_by_ids`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleanings.method = "POST" as const;

/**
 * 清掃のチェックインを確認する（cleaningIds は最大10,000件）
 * 
 */
export const checkCleaningsCheckinByIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/checkin`;
    return __queries ? `${__path}?${__queries}` : __path;
};
checkCleaningsCheckinByIds.method = "POST" as const;

/**
 * 清掃の、ユーザーごとの最新の承認リクエストを取得する
 * 
 */
export const listLatestApprovalRequestPerUserByCleaningIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/approval_requests/latest`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listLatestApprovalRequestPerUserByCleaningIds.method = "POST" as const;

/**
 * 清掃の、業者ごとの最新の承認リクエストを取得する
 * 
 */
export const listLatestCompanyApprovalRequestsByCleaningId = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/company_approval_requests/latest`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listLatestCompanyApprovalRequestsByCleaningId.method = "GET" as const;

/**
 * 清掃の特別ボーナスを更新する
 * 
 */
export const updateSpecialBonusByCleaningId = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/special_bonus`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateSpecialBonusByCleaningId.method = "POST" as const;

/**
 * クリーニングIDからスペシャルボーナスを取得する
 * 
 */
export const getSpecialBonusByCleaningId = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/special_bonus`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getSpecialBonusByCleaningId.method = "GET" as const;

/**
 * 清掃のスケジュールを更新する
 * 
 */
export const updateCleaningSchedule = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/schedule`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateCleaningSchedule.method = "POST" as const;

/**
 * 清掃の期限日時を更新する
 * 
 */
export const updateCleaningDeadline = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/deadline`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateCleaningDeadline.method = "PUT" as const;

/**
 * チェックインに遅れそうな清掃を取得する
 * 
 */
export const getOverdueCleanings = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/overdue_for_checkin`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getOverdueCleanings.method = "GET" as const;

/**
 * 業者管理者が清掃のインスペクター同行有無を登録する
 * 
 */
export const setInspectionByManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/inspection`;
    return __queries ? `${__path}?${__queries}` : __path;
};
setInspectionByManager.method = "PUT" as const;

/**
 * 清掃に紐づく忘れ物報告を取得する（Manager権限以上。{ total, reports } を返し、報告が無ければ reports は空配列）
 * 
 */
export const getLostItemReportsByCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/lost-items`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getLostItemReportsByCleaning.method = "GET" as const;

/**
 * 管理者が忘れ物の保管場所の写真をS3に直接アップロードするためのPresigned URLを取得する（Manager権限以上）
 * 
 */
export const issueLostItemReportImageUploadUrlForManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/lost-items/upload-url`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueLostItemReportImageUploadUrlForManager.method = "POST" as const;

/**
 * 管理者が別チャネルで共有を受けた忘れ物を代理で1件報告する（Manager権限以上。reported_byは操作した管理者）
 * 
 */
export const createLostItemReportForManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/lost-items`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createLostItemReportForManager.method = "POST" as const;

/**
 * 管理者が代理報告した忘れ物を削除する（Manager権限以上。Slack未通知の報告のみ削除できる）
 * 
 */
export const deleteLostItemReportForManager = ({cleaningId, reportId}: {cleaningId: string, reportId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/lost-items/${reportId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteLostItemReportForManager.method = "DELETE" as const;

/**
 * 管理者が清掃を忘れ物報告の対象か確認する（Manager権限以上。エリアで判定。現状は東京のみ対象）
 * 
 */
export const getLostItemReportTargetForManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/lost-items/target`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getLostItemReportTargetForManager.method = "GET" as const;

/**
 * オペレーションを取得する
 * 
 */
export const findOperationById = ({operationId}: {operationId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/operations/${operationId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findOperationById.method = "GET" as const;

/**
 * オペレーションを検索する
 * 
 */
export const searchOperations = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/operations/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchOperations.method = "POST" as const;

/**
 * オペレーションのトラブルを作成する
 * 
 */
export const createOperationManagerTrouble = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/operations/createTrouble`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createOperationManagerTrouble.method = "POST" as const;

/**
 * オペレーションの添付画像をアップロードする
 * 
 */
export const uploadOperationAttachmentImage = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/operations/${cleaningId}/attachment_images`;
    return __queries ? `${__path}?${__queries}` : __path;
};
uploadOperationAttachmentImage.method = "POST" as const;

/**
 * オペレーションの添付画像を取得する
 * 
 */
export const findOperationAttachmentImagesForManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/operations/${cleaningId}/attachment_images`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findOperationAttachmentImagesForManager.method = "GET" as const;

/**
 * オペレーションの添付画像を削除する
 * 
 */
export const deleteOperationAttachmentImage = ({imageId}: {imageId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/operations/attachment_images/${imageId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteOperationAttachmentImage.method = "DELETE" as const;

/**
 * オペレーションの件数を検索する
 * 
 */
export const countSearchOperations = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/operations/count`;
    return __queries ? `${__path}?${__queries}` : __path;
};
countSearchOperations.method = "POST" as const;

/**
 * オペレーションをsubmission_idで検索する
 * 
 */
export const searchOperationsBySubmissionId = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/operations/search/submission_id`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchOperationsBySubmissionId.method = "POST" as const;

/**
 * オペレーションの予約紐付けを更新する
 * 
 */
export const updateOperationReservationId = ({operationId}: {operationId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/operations/${operationId}/reservation`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateOperationReservationId.method = "PUT" as const;

/**
 * 作業員PhotoTourの回数を取得する
 * 
 */
export const getCleaningPhotoTourCounts = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/operationsCounts`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleaningPhotoTourCounts.method = "POST" as const;

/**
 * 清掃員が自身に紐づく清掃の一覧を取得する
 * 
 */
export const countActiveOperationsForCleaner = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleanings/count`;
    return __queries ? `${__path}?${__queries}` : __path;
};
countActiveOperationsForCleaner.method = "GET" as const;

/**
 * 写真ツアーを無効化する
 * 
 */
export const disablePhotoTour = ({photoTourId}: {photoTourId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/${photoTourId}/disable`;
    return __queries ? `${__path}?${__queries}` : __path;
};
disablePhotoTour.method = "PUT" as const;

/**
 * 写真ツアーを有効化する
 * 
 */
export const enablePhotoTour = ({photoTourId}: {photoTourId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/${photoTourId}/enable`;
    return __queries ? `${__path}?${__queries}` : __path;
};
enablePhotoTour.method = "PUT" as const;

/**
 * 写真ツアーのアイテムを無効化する
 * 
 */
export const disablePhotoTourItem = ({photoTourId, photoTourItemId}: {photoTourId: string, photoTourItemId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/${photoTourId}/items/${photoTourItemId}/disable`;
    return __queries ? `${__path}?${__queries}` : __path;
};
disablePhotoTourItem.method = "PUT" as const;

/**
 * 写真ツアーのアイテムを有効化する
 * 
 */
export const enablePhotoTourItem = ({photoTourId, photoTourItemId}: {photoTourId: string, photoTourItemId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/${photoTourId}/items/${photoTourItemId}/enable`;
    return __queries ? `${__path}?${__queries}` : __path;
};
enablePhotoTourItem.method = "PUT" as const;

/**
 * 写真ツアーの動画をアップロードする
 * 
 */
export const findPhotoTourMovie = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/cleaningId/${cleaningId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findPhotoTourMovie.method = "GET" as const;

/**
 * 写真ツアーの動画を削除する
 * 
 */
export const deletePhotoTourMovie = ({photoTourMovieId}: {photoTourMovieId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/${photoTourMovieId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deletePhotoTourMovie.method = "DELETE" as const;

/**
 * PlacementIDから写真ツアーの動画を取得する
 * 
 */
export const findPhotoTourMovieByPlacementId = ({placementId}: {placementId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/movies/placementId/${placementId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findPhotoTourMovieByPlacementId.method = "GET" as const;

/**
 * 写真ツアーのインデックスを再作成する
 * 
 */
export const reindexPhotoTourItems = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/reindex`;
    return __queries ? `${__path}?${__queries}` : __path;
};
reindexPhotoTourItems.method = "POST" as const;

/**
 * ツアー付きオペレーションの単価を保存する
 * 
 */
export const savePhotoTourUnitPrice = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tour_unit_price/save`;
    return __queries ? `${__path}?${__queries}` : __path;
};
savePhotoTourUnitPrice.method = "PUT" as const;

/**
 * Placementを取得する
 * 
 */
export const findPlacementById = ({placementId}: {placementId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/placements/${placementId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findPlacementById.method = "GET" as const;

/**
 * 会社IDからPlacementを取得する
 * 
 */
export const searchPlacements = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/placements/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchPlacements.method = "POST" as const;

/**
 * PlacementIdsからPlacementDetailsを取得する
 * 
 */
export const findPlacements = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/placements/find_by_ids`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findPlacements.method = "POST" as const;

/**
 * 共用部に紐づく清掃の画像を取得する
 * 
 */
export const findCleaningImageViewByCommonAreaId = ({commonAreaId}: {commonAreaId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/common_area/${commonAreaId}/imageView`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleaningImageViewByCommonAreaId.method = "GET" as const;

/**
 * 共用部を名前で検索する
 * 
 */
export const searchCommonAreaByName = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/common_area/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchCommonAreaByName.method = "POST" as const;

/**
 * 物件に紐づく清掃の画像を取得する
 * 
 */
export const findCleaningImageViewByListingId = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listing/${listingId}/imageView`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleaningImageViewByListingId.method = "GET" as const;

/**
 * 物件IDのリストからBigQueryデータを取得する（Manager権限以上）
 * 
 */
export const listBigQueryByListingIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/bigquery`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listBigQueryByListingIds.method = "POST" as const;

/**
 * 物件の滞在状況を取得する
 * 
 */
export const findListingStayStatus = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/stayStatus`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findListingStayStatus.method = "POST" as const;

/**
 * Check conflicts between checkin and tour operations
 * 
 */
export const findListingsConflictsCheckinAndTourOperation = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/conflictsCheckinAndTourOperation`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findListingsConflictsCheckinAndTourOperation.method = "GET" as const;

/**
 * 物件単位のゴミストッカー見本写真を取得する（上書きが無ければ global へフォールバック）
 * 
 */
export const getListingGarbageStorageSampleImage = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/garbage-storage/sample-image`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getListingGarbageStorageSampleImage.method = "GET" as const;

/**
 * 物件単位のゴミストッカー見本写真の S3 PUT Presigned URL を発行する
 * 
 */
export const issueListingGarbageStorageSampleImageUploadUrl = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/garbage-storage/sample-image/upload-url`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueListingGarbageStorageSampleImageUploadUrl.method = "POST" as const;

/**
 * 物件単位のゴミストッカー見本写真の S3 直接アップロード完了を通知する
 * 
 */
export const completeListingGarbageStorageSampleImageUpload = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/garbage-storage/sample-image/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeListingGarbageStorageSampleImageUpload.method = "POST" as const;

/**
 * 物件単位のゴミストッカー見本写真を削除する（global にフォールバック）
 * 
 */
export const deleteListingGarbageStorageSampleImage = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/garbage-storage/sample-image`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteListingGarbageStorageSampleImage.method = "DELETE" as const;

/**
 * ゴミストッカー見本写真（global）を取得する
 * 
 */
export const getGarbageStorageSampleImage = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/garbage-storage/sample-image`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getGarbageStorageSampleImage.method = "GET" as const;

/**
 * ゴミストッカー見本写真（global）の S3 PUT Presigned URL を発行する
 * 
 */
export const issueGarbageStorageSampleImageUploadUrl = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/garbage-storage/sample-image/upload-url`;
    return __queries ? `${__path}?${__queries}` : __path;
};
issueGarbageStorageSampleImageUploadUrl.method = "POST" as const;

/**
 * ゴミストッカー見本写真（global）の S3 直接アップロード完了を通知する
 * 
 */
export const completeGarbageStorageSampleImageUpload = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/garbage-storage/sample-image/complete`;
    return __queries ? `${__path}?${__queries}` : __path;
};
completeGarbageStorageSampleImageUpload.method = "POST" as const;

/**
 * ゴミストッカー見本写真（global）を削除する
 * 
 */
export const deleteGarbageStorageSampleImage = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/garbage-storage/sample-image`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteGarbageStorageSampleImage.method = "DELETE" as const;

/**
 * Webhookの一覧を取得する
 * 
 */
export const listWebhooks = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/webhooks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listWebhooks.method = "GET" as const;

/**
 * Webhookを作成する
 * 
 */
export const createWebhook = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/webhooks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createWebhook.method = "POST" as const;

/**
 * Webhookを更新する
 * 
 */
export const updateWebhook = ({webhookId}: {webhookId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/webhooks/${webhookId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateWebhook.method = "PUT" as const;

/**
 * Webhookを削除する
 * 
 */
export const deleteWebhook = ({webhookId}: {webhookId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/webhooks/${webhookId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteWebhook.method = "DELETE" as const;

/**
 * 通知を取得する
 * 
 */
export const getCompanyNotificationForManager = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/company_notification`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCompanyNotificationForManager.method = "GET" as const;

/**
 * 通知を更新する
 * 
 */
export const saveCompanyNotificationForManager = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/company_notification`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCompanyNotificationForManager.method = "PUT" as const;

/**
 * インセンティブ対象清掃員を登録/更新する
 * 
 */
export const saveIncentiveTargetCleaner = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/incentive_target_cleaners`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveIncentiveTargetCleaner.method = "PUT" as const;

/**
 * インセンティブ対象清掃員の一覧を取得する
 * 
 */
export const listIncentiveTargetCleaners = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/incentive_target_cleaners`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listIncentiveTargetCleaners.method = "GET" as const;

/**
 * 清掃員からの忘れ物報告をカテゴリ・期間・物件で検索する（Manager権限以上）
 * 
 */
export const searchLostItemReports = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/lost-items/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchLostItemReports.method = "POST" as const;

/**
 * 施設から部屋タイプのレコードをm2m-coreから同期する
 * 
 */
export const syncRoomTypes = ({propertyId}: {propertyId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/properties/${propertyId}/room-types-sync`;
    return __queries ? `${__path}?${__queries}` : __path;
};
syncRoomTypes.method = "POST" as const;

/**
 * 清掃のスケジュールを更新する
 * 
 */
export const updateCleaningScheduleForBiz = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/public/cleanings/${cleaningId}/schedule`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateCleaningScheduleForBiz.method = "POST" as const;

/**
 * 清掃員からの備品不足報告を期間・物件で検索する（Manager権限以上）
 * 
 */
export const searchRoomSupplyReports = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/room-supply/reports/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchRoomSupplyReports.method = "POST" as const;

/**
 * シフトの日付を更新する
 * 
 */
export const updateShiftDate = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/shift/date`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateShiftDate.method = "PUT" as const;

/**
 * シフトのステータスを更新する
 * 
 */
export const updateShiftsStatus = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/shifts/status`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateShiftsStatus.method = "PUT" as const;

/**
 * シフトを取得する
 * 
 */
export const listShifts = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/shifts/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listShifts.method = "POST" as const;

/**
 * 全てのタグを取得する
 * 
 */
export const getAllTags = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/tags`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getAllTags.method = "GET" as const;

/**
 * 指定日の自社の交通費申請一覧を取得する（Manager権限以上）
 * 
 */
export const listTransportationExpensesByDate = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/transportation_expenses/list_by_date`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listTransportationExpensesByDate.method = "POST" as const;

/**
 * 1件の清掃に割り当てられた全清掃員を解除する
 * 
 */
export const unassignAllCleanerByCleaningId = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/unassign/allCleaners/${cleaningId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
unassignAllCleanerByCleaningId.method = "DELETE" as const;

/**
 * 単価の計算式を保存する
 * 
 */
export const saveUnitPriceFormula = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/unit_price_formula/save`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveUnitPriceFormula.method = "PUT" as const;

/**
 * 単価の計算式を取得する
 * 
 */
export const findUnitPriceFormula = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/unit_price_formula/find`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findUnitPriceFormula.method = "GET" as const;

/**
 * 管理者が自社に関わる設定を閲覧する
 * 
 */
export const getTenantSetting = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/settings/ownTenant`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getTenantSetting.method = "GET" as const;

/**
 * 管理者が自社へのメール通知に使うアドレスを更新する
 * 
 */
export const updateManagerNotifierEmailAddresses = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/settings/ownTenant/managerNotifierEmailAddresses`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateManagerNotifierEmailAddresses.method = "PUT" as const;

/**
 * トラブルを検索する
 * 
 */
export const searchTroubles = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/troubles/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchTroubles.method = "POST" as const;

/**
 * トラブルを取得する
 * 
 */
export const findTroubleById = ({troubleId}: {troubleId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/troubles/${troubleId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findTroubleById.method = "GET" as const;

/**
 * トラブルを管理者が作成する
 * 
 */
export const createTroubleByManager = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/troubles`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createTroubleByManager.method = "POST" as const;

/**
 * トラブルに対するコメント一覧を取得する
 * 
 */
export const listCommentsByTroubleId = ({troubleId}: {troubleId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/troubles/${troubleId}/comments`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCommentsByTroubleId.method = "GET" as const;

/**
 * トラブルにコメントを投稿する
 * 
 */
export const createTroubleComment = ({troubleId}: {troubleId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/troubles/${troubleId}/comments`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createTroubleComment.method = "POST" as const;

/**
 * トラブルのコメントを更新する
 * 
 */
export const updateTroubleComment = ({troubleId}: {troubleId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/troubles/${troubleId}/comments`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateTroubleComment.method = "PUT" as const;

/**
 * トラブルのコメントを削除する
 * 
 */
export const deleteTroubleComment = ({troubleId, commentId}: {troubleId: string, commentId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/troubles/${troubleId}/comments/${commentId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteTroubleComment.method = "DELETE" as const;

/**
 * 物件を取得する
 * 
 */
export const getListingById = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getListingById.method = "GET" as const;

/**
 * 物件に対する清掃一覧を取得する
 * 
 */
export const findCleaningsByListingId = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/cleanings/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleaningsByListingId.method = "POST" as const;

/**
 * 物件の情報を更新する
 * 
 */
export const updateListing = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateListing.method = "PUT" as const;

/**
 * 物件IDのリストから物件を検索する
 * 
 */
export const findListingsByIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/search_by_ids`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findListingsByIds.method = "POST" as const;

/**
 * 物件の請求を検索する
 * 
 */
export const searchListingInvoice = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listing_invoices/search`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchListingInvoice.method = "POST" as const;

/**
 * 物件の請求をエクスポートする
 * 
 */
export const exportListingInvoice = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listing_invoices/export`;
    return __queries ? `${__path}?${__queries}` : __path;
};
exportListingInvoice.method = "POST" as const;

/**
 * 物件の請求を取得する
 * 
 */
export const findListingInvoiceById = ({invoiceId}: {invoiceId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listing_invoices/${invoiceId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findListingInvoiceById.method = "GET" as const;

/**
 * 物件に請求を作成する
 * 
 */
export const createListingInvoice = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listing_invoices`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createListingInvoice.method = "POST" as const;

/**
 * 物件の請求を更新する
 * 
 */
export const patchListingInvoice = ({invoiceId}: {invoiceId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listing_invoices/${invoiceId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
patchListingInvoice.method = "PATCH" as const;

/**
 * 清掃員の単価情報を取得する
 * 
 */
export const findCleanerCostByUserId = ({userId}: {userId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaners/${userId}/cost`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleanerCostByUserId.method = "GET" as const;

/**
 * 清掃員の単価情報を保存する
 * 
 */
export const saveCleanerCostByUserId = ({userId}: {userId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaners/${userId}/cost`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCleanerCostByUserId.method = "PUT" as const;

/**
 * 管理者が清掃員の情報を更新する
 * 
 */
export const updateUserByManager = ({userId}: {userId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/users/${userId}/update_by_manager`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateUserByManager.method = "POST" as const;

/**
 * 清掃の履歴を取得する
 * 
 */
export const findEventHistoriesByCleaningId = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/event_histories/search_by_cleaning_id/${cleaningId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findEventHistoriesByCleaningId.method = "GET" as const;

/**
 * 清掃IDのリストから予約を検索する
 * 
 */
export const searchReservationsByCleaningIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/reservations/search_by_cleaning_ids`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchReservationsByCleaningIds.method = "POST" as const;

/**
 * 清掃IDのリストから次の予約を検索する
 * 
 */
export const searchNextReservationsByCleaningIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/reservations/search_next_by_cleaning_ids`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchNextReservationsByCleaningIds.method = "POST" as const;

/**
 * 物件とチェックアウト日から予約を取得する
 * 
 */
export const findReservationByListingAndEndDate = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/reservations/find_reservation_by_listing_and_end_date`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findReservationByListingAndEndDate.method = "POST" as const;

/**
 * 写真ツアーを取得する
 * @param {string} isAssigned true
 */
export const findPhotoTours = ({isAssigned}: {isAssigned?: string}) => {
    const __root = root();
    const __queries = Object.entries({isAssigned})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findPhotoTours.method = "GET" as const;

/**
 * 写真ツアーを作成する
 * 
 */
export const createPhotoTour = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createPhotoTour.method = "POST" as const;

/**
 * 写真ツアーを更新する
 * 
 */
export const updatePhotoTour = ({photoTourId}: {photoTourId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/${photoTourId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updatePhotoTour.method = "PUT" as const;

/**
 * 写真ツアーのアイテムを取得する
 * 
 */
export const findPhotoTourItemsByPhotoTourId = ({photoTourId}: {photoTourId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/${photoTourId}/items`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findPhotoTourItemsByPhotoTourId.method = "GET" as const;

/**
 * 写真ツアーのアイテムを作成する
 * 
 */
export const createPhotoTourItem = ({photoTourId}: {photoTourId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/${photoTourId}/items`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createPhotoTourItem.method = "POST" as const;

/**
 * 写真ツアーのアイテムを更新する
 * 
 */
export const updatePhotoTourItem = ({photoTourId, photoTourItemId}: {photoTourId: string, photoTourItemId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/${photoTourId}/items/${photoTourItemId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updatePhotoTourItem.method = "PUT" as const;

/**
 * 写真ツアーのアイテムを削除する
 * 
 */
export const deletePhotoTourItem = ({photoTourId, photoTourItemId}: {photoTourId: string, photoTourItemId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tours/${photoTourId}/items/${photoTourItemId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deletePhotoTourItem.method = "DELETE" as const;

/**
 * 清掃IDから写真ツアーの画像を取得する
 * 
 */
export const findPhotoTourImagesByCleaningId = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tour_images/by_cleaning_id/${cleaningId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findPhotoTourImagesByCleaningId.method = "GET" as const;

/**
 * 写真ツアーの画像をアップロードする
 * 
 */
export const uploadPhotoTourImage = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tour_images`;
    return __queries ? `${__path}?${__queries}` : __path;
};
uploadPhotoTourImage.method = "POST" as const;

/**
 * 写真ツアーの画像を削除する
 * 
 */
export const deletePhotoTourImage = ({photoTourImageId}: {photoTourImageId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tour_images/${photoTourImageId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deletePhotoTourImage.method = "DELETE" as const;

/**
 * 写真ツアーのアイテムのサンプル画像を作成する
 * 
 */
export const createPhotoTourItemSampleImage = ({photoTourItemId}: {photoTourItemId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tour_items/${photoTourItemId}/sample_images`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createPhotoTourItemSampleImage.method = "POST" as const;

/**
 * 写真ツアーのアイテムのサンプル画像を取得する
 * 
 */
export const findPhotoTourItemSampleImagesByPhotoTourItemId = ({photoTourItemId}: {photoTourItemId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tour_items/${photoTourItemId}/sample_images`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findPhotoTourItemSampleImagesByPhotoTourItemId.method = "GET" as const;

/**
 * 写真ツアーのアイテムのサンプル画像を更新する
 * 
 */
export const updatePhotoTourItemSampleImage = ({photoTourItemSampleImageId}: {photoTourItemSampleImageId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tour_item_sample_images/${photoTourItemSampleImageId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updatePhotoTourItemSampleImage.method = "PUT" as const;

/**
 * 写真ツアーのアイテムのサンプル画像を削除する
 * 
 */
export const deletePhotoTourItemSampleImage = ({photoTourItemSampleImageId}: {photoTourItemSampleImageId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/photo_tour_item_sample_images/${photoTourItemSampleImageId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deletePhotoTourItemSampleImage.method = "DELETE" as const;

/**
 * 指定した物件の清掃を会社間で移動する
 * 
 */
export const transferCleaning = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/transfer_cleaning`;
    return __queries ? `${__path}?${__queries}` : __path;
};
transferCleaning.method = "POST" as const;

/**
 * 清掃をPlacementを指定して作成する(system用)
 * 
 */
export const createCleaningWithPlacementSystem = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/system/cleanings/create_with_placement`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createCleaningWithPlacementSystem.method = "POST" as const;

/**
 * 清掃をphoto_tour_idを指定して取得する(system用)
 * 
 */
export const findCleaningsWithPhotoTourIdsForSystem = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/system/cleanings/with_photo_tour_ids`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleaningsWithPhotoTourIdsForSystem.method = "POST" as const;

/**
 * 清掃を更新する(system用)
 * 
 */
export const updateCleaningSystem = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/system/cleanings/${cleaningId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateCleaningSystem.method = "PUT" as const;

/**
 * 物件IDから共用部分を取得する
 * 
 */
export const findCommonAreaByPropertyId = ({propertyId}: {propertyId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/common_areas/by_property_id/${propertyId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCommonAreaByPropertyId.method = "GET" as const;

/**
 * 会社IDから共用部分を取得する
 * 
 */
export const findCommonAreasByCompanyId = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/common_areas/by_company_id`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCommonAreasByCompanyId.method = "GET" as const;

/**
 * 共用部分を取得する
 * 
 */
export const findCommonAreaById = ({commonAreaId}: {commonAreaId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/common_areas/${commonAreaId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCommonAreaById.method = "GET" as const;

/**
 * 物件を取得する
 * 
 */
export const findPropertyById = ({propertyId}: {propertyId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/properties/${propertyId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findPropertyById.method = "GET" as const;

/**
 * 会社IDから物件を取得する
 * 
 */
export const findPropertiesByCompanyId = ({companyId}: {companyId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/properties/by_company_id/${companyId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findPropertiesByCompanyId.method = "GET" as const;

/**
 * @deprecated 物件管理者がお願いごとを作成する
 * 
 */
export const createErrandsByListingManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/errands`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createErrandsByListingManager.method = "POST" as const;

/**
 * @deprecated 物件管理者がお願い事を削除する
 * 
 */
export const deleteErrandByListingManager = ({cleaningId, errandId}: {cleaningId: string, errandId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/errands/${errandId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteErrandByListingManager.method = "DELETE" as const;

/**
 * 物件管理者が報告された写真のurlを一覧する
 * 
 */
export const listCleaningTaskResultPictures = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/tasks/pictures`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCleaningTaskResultPictures.method = "GET" as const;

/**
 * 清掃のキーボックス番号履歴を取得する（清掃業者対応）
 * 
 */
export const getCleaningKeyboxRotationHistories = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/keybox_rotation_histories`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleaningKeyboxRotationHistories.method = "GET" as const;

/**
 * 清掃のスペアキーボックス番号変更履歴を取得する（清掃業者対応）
 * 
 */
export const getCleaningSpareKeyboxNumberRotationHistories = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/spare_keybox_number_rotation_histories`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleaningSpareKeyboxNumberRotationHistories.method = "GET" as const;

/**
 * 清掃のゴミストッカー溢れチェック報告を取得する
 * 
 */
export const getGarbageStorageCheck = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/garbage-storage/check`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getGarbageStorageCheck.method = "GET" as const;

/**
 * 清掃の単価情報を取得する
 * 
 */
export const findCleaningCostByCleaningId = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/cost`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleaningCostByCleaningId.method = "GET" as const;

/**
 * 清掃の単価情報を保存する
 * 
 */
export const saveCleaningCostByCleaningId = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/cost`;
    return __queries ? `${__path}?${__queries}` : __path;
};
saveCleaningCostByCleaningId.method = "PUT" as const;

/**
 * 三条書面を作成する
 * 
 */
export const createSubcontract3 = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/subcontract3`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createSubcontract3.method = "POST" as const;

/**
 * 管理者が清掃写真をアップロードする
 * 
 */
export const uploadEvidencePictureByListingManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/evidence`;
    return __queries ? `${__path}?${__queries}` : __path;
};
uploadEvidencePictureByListingManager.method = "POST" as const;

/**
 * 管理者が清掃写真を削除する
 * 
 */
export const deleteEvidencePictureByListingManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/evidence`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteEvidencePictureByListingManager.method = "DELETE" as const;

/**
 * 清掃をPlacementを指定して作成する
 * 
 */
export const createCleaningWithPlacement = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/create_with_placement`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createCleaningWithPlacement.method = "POST" as const;

/**
 * 清掃をPlacementを指定してバッチ作成する（最大1000件）
 * 
 */
export const batchCreateCleaningWithPlacement = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/batch_create_with_placement`;
    return __queries ? `${__path}?${__queries}` : __path;
};
batchCreateCleaningWithPlacement.method = "POST" as const;

/**
 * 清掃をPlacementを指定して取得する,デフォルトは1000件上限,pageとpageSize両方を指定した場合にはその上限を超えて10000件まで取得可能,pageSize10000超えてリクエスト可能だがその場合10000件指定と同じ結果を返す
 * 
 */
export const findCleaningsWithPlacement = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/with_placement`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleaningsWithPlacement.method = "POST" as const;

/**
 * 清掃をphoto_tour_idを指定して取得する
 * 
 */
export const findCleaningsWithPhotoTourIds = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/with_photo_tour_ids`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleaningsWithPhotoTourIds.method = "POST" as const;

/**
 * 自社の清掃実績一覧を取得する
 * 
 */
export const listCleaningAchievements = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/achievements`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCleaningAchievements.method = "POST" as const;

/**
 * 委譲先の清掃実績一覧を取得する
 * 
 */
export const listDelegateCleaningAchievements = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/delegate_cleanings/achievements`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listDelegateCleaningAchievements.method = "POST" as const;

/**
 * 物件管理者が自社のリスティングの一覧を取得する
 * 
 */
export const listListings = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listListings.method = "GET" as const;

/**
 * ある物件の全ての清掃タイプの清掃料金を取得する
 * 
 */
export const getCleaningTypeFeeListByListing = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/cleaning_type_fee_list`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleaningTypeFeeListByListing.method = "GET" as const;

/**
 * 物件の清掃タイプごとの清掃料金を更新する
 * 
 */
export const putCleaningTypeFeeListByListing = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/cleaning_type_fee_list`;
    return __queries ? `${__path}?${__queries}` : __path;
};
putCleaningTypeFeeListByListing.method = "PUT" as const;

/**
 * 自社に管理を委譲された物件一覧を取得する
 * 
 */
export const listDelegatedListings = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/listings/delegated`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listDelegatedListings.method = "GET" as const;

/**
 * 清掃マニュアルの画像をアップロードする
 * 
 */
export const uploadManualPicture = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/manual_pictures`;
    return __queries ? `${__path}?${__queries}` : __path;
};
uploadManualPicture.method = "POST" as const;

/**
 * ヘルスチェックを行う
 * 
 */
export const healthCheck = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/health_check`;
    return __queries ? `${__path}?${__queries}` : __path;
};
healthCheck.method = "GET" as const;

/**
 * チェック項目の一覧を取得する
 * 
 */
export const listCheckitems = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/checkitems`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCheckitems.method = "GET" as const;

/**
 * チェック項目の一覧を保存する
 * 
 */
export const setCheckitems = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/checkitems`;
    return __queries ? `${__path}?${__queries}` : __path;
};
setCheckitems.method = "PUT" as const;

/**
 * 清掃に紐づくお願い事を一覧する
 * 
 */
export const listErrands = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/errands`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listErrands.method = "GET" as const;

/**
 * 割り当てられた清掃員の一覧を取得する
 * 
 */
export const listAssignedCleaners = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/cleaners`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listAssignedCleaners.method = "GET" as const;

/**
 * 清掃員を割り当てる
 * 
 */
export const assignCleaners = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/cleaners`;
    return __queries ? `${__path}?${__queries}` : __path;
};
assignCleaners.method = "POST" as const;

/**
 * 清掃員の割り当てを解除する
 * 
 */
export const unassignCleaners = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/cleaners`;
    return __queries ? `${__path}?${__queries}` : __path;
};
unassignCleaners.method = "DELETE" as const;

/**
 * 清掃に業者をアサインする
 * 
 */
export const assignCompany = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/company`;
    return __queries ? `${__path}?${__queries}` : __path;
};
assignCompany.method = "POST" as const;

/**
 * 清掃の業者アサインを解除する
 * 
 */
export const unassignCompany = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/company`;
    return __queries ? `${__path}?${__queries}` : __path;
};
unassignCompany.method = "DELETE" as const;

/**
 * トラブル一覧を取得する
 * 
 */
export const listTroubles = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/troubles`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listTroubles.method = "GET" as const;

/**
 * 物件管理者が請求を取得する
 * 
 */
export const findInvoiceByListingManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/listing_manager_invoices`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findInvoiceByListingManager.method = "GET" as const;

/**
 * 物件管理者が請求を更新する
 * 
 */
export const updateInvoiceByListingManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/listing_manager_invoices`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateInvoiceByListingManager.method = "PUT" as const;

/**
 * 清掃管理者が請求を取得する
 * 
 */
export const findInvoiceByCleaningManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/cleaning_manager_invoices`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findInvoiceByCleaningManager.method = "GET" as const;

/**
 * 清掃管理者が請求を更新する
 * 
 */
export const updateInvoiceByCleaningManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/cleaning_manager_invoices`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateInvoiceByCleaningManager.method = "PUT" as const;

/**
 * アサイン可能な業者一覧を取得する
 * 
 */
export const listAssignableCompanies = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/assignable_companies`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listAssignableCompanies.method = "GET" as const;

/**
 * 業者が清掃の承認リクエストを承認する
 * 
 */
export const approveCompanyRequest = ({companyApprovalRequestId}: {companyApprovalRequestId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/company/approval-requests/${companyApprovalRequestId}/approve`;
    return __queries ? `${__path}?${__queries}` : __path;
};
approveCompanyRequest.method = "POST" as const;

/**
 * 業者が清掃の承認リクエストを拒否する
 * 
 */
export const rejectCompanyRequest = ({companyApprovalRequestId}: {companyApprovalRequestId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/company/approval-requests/${companyApprovalRequestId}/reject`;
    return __queries ? `${__path}?${__queries}` : __path;
};
rejectCompanyRequest.method = "POST" as const;

/**
 * 業者向け承認リクエスト一括承認
 * 
 */
export const bulkApproveCompanyRequests = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/company/approval-requests/bulk-approve`;
    return __queries ? `${__path}?${__queries}` : __path;
};
bulkApproveCompanyRequests.method = "POST" as const;

/**
 * 業者向けPending承認リクエスト件数を取得する
 * 
 */
export const countPendingCompanyApprovalRequests = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/company/approval-requests/pending/count`;
    return __queries ? `${__path}?${__queries}` : __path;
};
countPendingCompanyApprovalRequests.method = "GET" as const;

/**
 * 業者向けPending承認リクエスト一覧を取得する
 * 
 */
export const listPendingCompanyApprovalRequests = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/company/approval-requests/pending`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listPendingCompanyApprovalRequests.method = "GET" as const;

/**
 * 業者が下請法の書面を取得する
 * 
 */
export const getCompanySubContractDocumentByCompanyApprovalRequestId = ({companyApprovalRequestId}: {companyApprovalRequestId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/company/company_approval_request/${companyApprovalRequestId}/sub_contract_document`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCompanySubContractDocumentByCompanyApprovalRequestId.method = "GET" as const;

/**
 * 業者が下請法の書面PDFを取得する
 * 
 */
export const createCompanySubContractDocumentPdfByCompanyApprovalRequestId = ({companyApprovalRequestId}: {companyApprovalRequestId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/company/company_approval_request/${companyApprovalRequestId}/create_pdf`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createCompanySubContractDocumentPdfByCompanyApprovalRequestId.method = "GET" as const;

/**
 * 清掃管理者が物件名,日付で清掃を検索する
 * 
 */
export const searchCleanings = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/search/cleanings`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchCleanings.method = "POST" as const;

/**
 * 清掃管理者が物件名,日付で清掃を検索する
 * 
 */
export const searchDelegateCleanings = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/search/delegate_cleanings`;
    return __queries ? `${__path}?${__queries}` : __path;
};
searchDelegateCleanings.method = "POST" as const;

/**
 * OtaIDから清掃を検索する
 * 
 */
export const findCleaningsByOtaId = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/search_cleanings/ota_id`;
    return __queries ? `${__path}?${__queries}` : __path;
};
findCleaningsByOtaId.method = "POST" as const;

/**
 * 物件の清掃管理を委譲する
 * 
 */
export const delegateListing = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/delegation`;
    return __queries ? `${__path}?${__queries}` : __path;
};
delegateListing.method = "PUT" as const;

/**
 * 物件の清掃管理の委譲を削除する
 * 
 */
export const undelegateListing = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/delegation`;
    return __queries ? `${__path}?${__queries}` : __path;
};
undelegateListing.method = "DELETE" as const;

/**
 * 物件固有の清掃マニュアルの一覧を取得する.
 * 
 */
export const getManualsOfListing = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/manuals`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getManualsOfListing.method = "GET" as const;

/**
 * 物件固有の清掃マニュアルを作成する.
 * 
 */
export const createManualOfListing = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/manuals`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createManualOfListing.method = "POST" as const;

/**
 * 物件固有の清掃マニュアルを更新する.
 * 
 */
export const updateManualOfListing = ({listingId, manualId}: {listingId: string, manualId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/manuals/${manualId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateManualOfListing.method = "PUT" as const;

/**
 * 物件固有の清掃マニュアルを削除する.
 * 
 */
export const deleteManualOfListing = ({listingId, manualId}: {listingId: string, manualId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/manuals/${manualId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteManualOfListing.method = "DELETE" as const;

/**
 * 物件管理者が委譲先に対して清掃を作成する
 * 
 */
export const createCleaningOfListing = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/cleanings`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createCleaningOfListing.method = "POST" as const;

/**
 * 物件に紐づくタスク一覧を取得する
 * 
 */
export const listListingTasks = ({listingId}: {listingId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/listings/${listingId}/tasks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listListingTasks.method = "GET" as const;

/**
 * タスク一覧を取得する
 * 
 */
export const listTasks = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/tasks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listTasks.method = "GET" as const;

/**
 * タスク一覧を設定する
 * 
 */
export const setTasks = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/tasks`;
    return __queries ? `${__path}?${__queries}` : __path;
};
setTasks.method = "POST" as const;

/**
 * タスクを更新する
 * 
 */
export const updateTasks = ({taskId}: {taskId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/tasks/${taskId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateTasks.method = "PUT" as const;

/**
 * 指定したタスクを削除する
 * 
 */
export const deleteTask = ({taskId}: {taskId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/tasks/${taskId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteTask.method = "DELETE" as const;

/**
 * 物件と清掃箇所の紐づけを一括更新する
 * 
 */
export const bulkUpdateListingCleaningTaskRelations = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/tasks/listing-relations`;
    return __queries ? `${__path}?${__queries}` : __path;
};
bulkUpdateListingCleaningTaskRelations.method = "POST" as const;

/**
 * 清掃マニュアルの一覧を取得する.
 * 
 */
export const getManuals = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/manuals`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getManuals.method = "GET" as const;

/**
 * 清掃マニュアルを作成する.
 * 
 */
export const createManual = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/manuals`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createManual.method = "POST" as const;

/**
 * 清掃マニュアルを取得する.
 * 
 */
export const getManual = ({manualId}: {manualId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/manuals/${manualId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getManual.method = "GET" as const;

/**
 * 清掃マニュアルを更新する.
 * 
 */
export const updateManual = ({manualId}: {manualId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/manuals/${manualId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateManual.method = "PUT" as const;

/**
 * 清掃マニュアルを削除する.
 * 
 */
export const deleteManual = ({manualId}: {manualId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/manuals/${manualId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
deleteManual.method = "DELETE" as const;

/**
 * 自社の清掃員一覧を取得する
 * 
 */
export const listCleaners = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleaners`;
    return __queries ? `${__path}?${__queries}` : __path;
};
listCleaners.method = "GET" as const;

/**
 * 清掃員の情報を更新する
 * 
 */
export const updateCleaners = ({cleanerId}: {cleanerId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/mypage/cleaners/${cleanerId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateCleaners.method = "PUT" as const;

/**
 * 清掃員を作成する
 * 
 */
export const createCleaner = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaners`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createCleaner.method = "POST" as const;

/**
 * 清掃員をインポートする
 * 
 */
export const importCleanerByEmail = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaners/import`;
    return __queries ? `${__path}?${__queries}` : __path;
};
importCleanerByEmail.method = "POST" as const;

/**
 * 清掃の通知を物件ごとに再送する
 * 
 */
export const cleaningEventRenotifyByListing = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaningEvents/renotify_by_listing`;
    return __queries ? `${__path}?${__queries}` : __path;
};
cleaningEventRenotifyByListing.method = "POST" as const;

/**
 * 清掃の通知を日付範囲を指定して再送する
 * 
 */
export const cleaningEventRenotifyByDateSpan = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleaningEvents/renotify_by_datespan`;
    return __queries ? `${__path}?${__queries}` : __path;
};
cleaningEventRenotifyByDateSpan.method = "POST" as const;

/**
 * トラブルを解決する
 * 
 */
export const resolveTrouble = ({troubleId}: {troubleId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/troubles/${troubleId}/resolve`;
    return __queries ? `${__path}?${__queries}` : __path;
};
resolveTrouble.method = "POST" as const;

/**
 * トラブルを未解決に戻す
 * 
 */
export const unresolveTrouble = ({troubleId}: {troubleId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/troubles/${troubleId}/unresolve`;
    return __queries ? `${__path}?${__queries}` : __path;
};
unresolveTrouble.method = "POST" as const;

/**
 * 清掃を新規作成する
 * 
 */
export const createCleaning = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings`;
    return __queries ? `${__path}?${__queries}` : __path;
};
createCleaning.method = "POST" as const;

/**
 * 清掃を更新する
 * 
 */
export const updateCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateCleaning.method = "PUT" as const;

/**
 * 物件管理者が清掃を更新する
 * 
 */
export const updateCleaningByListingManager = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/listing_manager`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateCleaningByListingManager.method = "PUT" as const;

/**
 * 清掃業者が清掃を更新する
 * 
 */
export const updateCleaningByCleaningCompany = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}/cleaning_company`;
    return __queries ? `${__path}?${__queries}` : __path;
};
updateCleaningByCleaningCompany.method = "PUT" as const;

/**
 * 指定した清掃を取得する
 * 
 */
export const getCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/cleanings/${cleaningId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getCleaning.method = "GET" as const;

/**
 * 委譲先の清掃を取得する
 * 
 */
export const getDelegateCleaning = ({cleaningId}: {cleaningId: string}) => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/delegate_cleanings/${cleaningId}`;
    return __queries ? `${__path}?${__queries}` : __path;
};
getDelegateCleaning.method = "GET" as const;

/**
 * 指定した物件の指定した日付以降の清掃を会社間で移動する
 * 
 */
export const transferCleanings = () => {
    const __root = root();
    const __queries = Object.entries({})
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
    const __path = `${__root}/v4/transfer_cleanings`;
    return __queries ? `${__path}?${__queries}` : __path;
};
transferCleanings.method = "POST" as const;
export const m2mCleaning_managerV4 = {checkCleanerApplicantAntisocial,searchAntisocialChecks,issueAntisocialCheckArticleListUrl,createCityGroups,deleteCityGroup,updateCityGroups,readCityGroups,reorderCityGroups,saveCleanerAssessment,saveCleanerAutoAssignEnabled,saveCleanerFactor,saveCleanerHome,listCleanerHome,saveCleanerRemarks,saveCleanerSkill,saveCleanerTag,deleteAllCleanerTags,saveCleanerUnitPrice,findCleanerUnitPricesByCleanerIds,getFeatureFlags,listFeatureFlagDefinitions,listFeatureFlagTargetCompanies,updateFeatureFlagStatus,updateFeatureFlagGlobalEnabled,addFeatureFlagTargets,deleteRetiredFeatureFlag,deleteFeatureFlagTarget,searchFeedbacks,registerCleanerPathWithCleanerId,registerCleanerPath,listCleanerPath,listCleanerPathByDateAndUser,updateCleanerPath,listCleanerRolesByUserIds,saveCleanerRole,findDetailsByCleanerIds,findCleaningIdsByDateAndCleanerIds,findCleanerTagsByCleanerIds,getCleaningStatus,getCleaningTimeline,getCleaningWebhook,saveCleaningWebhook,listCleaningsForDay,exportCleaningsForDayCsv,getCleaningsForDayStatistics,findCleanings,checkCleaningsCheckinByIds,listLatestApprovalRequestPerUserByCleaningIds,listLatestCompanyApprovalRequestsByCleaningId,updateSpecialBonusByCleaningId,getSpecialBonusByCleaningId,updateCleaningSchedule,updateCleaningDeadline,getOverdueCleanings,setInspectionByManager,getLostItemReportsByCleaning,issueLostItemReportImageUploadUrlForManager,createLostItemReportForManager,deleteLostItemReportForManager,getLostItemReportTargetForManager,findOperationById,searchOperations,createOperationManagerTrouble,uploadOperationAttachmentImage,findOperationAttachmentImagesForManager,deleteOperationAttachmentImage,countSearchOperations,searchOperationsBySubmissionId,updateOperationReservationId,getCleaningPhotoTourCounts,countActiveOperationsForCleaner,disablePhotoTour,enablePhotoTour,disablePhotoTourItem,enablePhotoTourItem,findPhotoTourMovie,deletePhotoTourMovie,findPhotoTourMovieByPlacementId,reindexPhotoTourItems,savePhotoTourUnitPrice,findPlacementById,searchPlacements,findPlacements,findCleaningImageViewByCommonAreaId,searchCommonAreaByName,findCleaningImageViewByListingId,listBigQueryByListingIds,findListingStayStatus,findListingsConflictsCheckinAndTourOperation,getListingGarbageStorageSampleImage,issueListingGarbageStorageSampleImageUploadUrl,completeListingGarbageStorageSampleImageUpload,deleteListingGarbageStorageSampleImage,getGarbageStorageSampleImage,issueGarbageStorageSampleImageUploadUrl,completeGarbageStorageSampleImageUpload,deleteGarbageStorageSampleImage,listWebhooks,createWebhook,updateWebhook,deleteWebhook,getCompanyNotificationForManager,saveCompanyNotificationForManager,saveIncentiveTargetCleaner,listIncentiveTargetCleaners,searchLostItemReports,syncRoomTypes,updateCleaningScheduleForBiz,searchRoomSupplyReports,updateShiftDate,updateShiftsStatus,listShifts,getAllTags,listTransportationExpensesByDate,unassignAllCleanerByCleaningId,saveUnitPriceFormula,findUnitPriceFormula,getTenantSetting,updateManagerNotifierEmailAddresses,searchTroubles,findTroubleById,createTroubleByManager,listCommentsByTroubleId,createTroubleComment,updateTroubleComment,deleteTroubleComment,getListingById,findCleaningsByListingId,updateListing,findListingsByIds,searchListingInvoice,exportListingInvoice,findListingInvoiceById,createListingInvoice,patchListingInvoice,findCleanerCostByUserId,saveCleanerCostByUserId,updateUserByManager,findEventHistoriesByCleaningId,searchReservationsByCleaningIds,searchNextReservationsByCleaningIds,findReservationByListingAndEndDate,findPhotoTours,createPhotoTour,updatePhotoTour,findPhotoTourItemsByPhotoTourId,createPhotoTourItem,updatePhotoTourItem,deletePhotoTourItem,findPhotoTourImagesByCleaningId,uploadPhotoTourImage,deletePhotoTourImage,createPhotoTourItemSampleImage,findPhotoTourItemSampleImagesByPhotoTourItemId,updatePhotoTourItemSampleImage,deletePhotoTourItemSampleImage,transferCleaning,createCleaningWithPlacementSystem,findCleaningsWithPhotoTourIdsForSystem,updateCleaningSystem,findCommonAreaByPropertyId,findCommonAreasByCompanyId,findCommonAreaById,findPropertyById,findPropertiesByCompanyId,createErrandsByListingManager,deleteErrandByListingManager,listCleaningTaskResultPictures,getCleaningKeyboxRotationHistories,getCleaningSpareKeyboxNumberRotationHistories,getGarbageStorageCheck,findCleaningCostByCleaningId,saveCleaningCostByCleaningId,createSubcontract3,uploadEvidencePictureByListingManager,deleteEvidencePictureByListingManager,createCleaningWithPlacement,batchCreateCleaningWithPlacement,findCleaningsWithPlacement,findCleaningsWithPhotoTourIds,listCleaningAchievements,listDelegateCleaningAchievements,listListings,getCleaningTypeFeeListByListing,putCleaningTypeFeeListByListing,listDelegatedListings,uploadManualPicture,healthCheck,listCheckitems,setCheckitems,listErrands,listAssignedCleaners,assignCleaners,unassignCleaners,assignCompany,unassignCompany,listTroubles,findInvoiceByListingManager,updateInvoiceByListingManager,findInvoiceByCleaningManager,updateInvoiceByCleaningManager,listAssignableCompanies,approveCompanyRequest,rejectCompanyRequest,bulkApproveCompanyRequests,countPendingCompanyApprovalRequests,listPendingCompanyApprovalRequests,getCompanySubContractDocumentByCompanyApprovalRequestId,createCompanySubContractDocumentPdfByCompanyApprovalRequestId,searchCleanings,searchDelegateCleanings,findCleaningsByOtaId,delegateListing,undelegateListing,getManualsOfListing,createManualOfListing,updateManualOfListing,deleteManualOfListing,createCleaningOfListing,listListingTasks,listTasks,setTasks,updateTasks,deleteTask,bulkUpdateListingCleaningTaskRelations,getManuals,createManual,getManual,updateManual,deleteManual,listCleaners,updateCleaners,createCleaner,importCleanerByEmail,cleaningEventRenotifyByListing,cleaningEventRenotifyByDateSpan,resolveTrouble,unresolveTrouble,createCleaning,updateCleaning,updateCleaningByListingManager,updateCleaningByCleaningCompany,getCleaning,getDelegateCleaning,transferCleanings};
